import type { ElementType, ReactNode } from 'react'

interface ProfileCardShellProps {
  /** Header icon (a lucide icon component). */
  icon: ElementType
  /** Uppercase header title. */
  title: string
  /** Optional right-side element (action button, status badge, …). */
  right?: ReactNode
  /** Card body. */
  children: ReactNode
  /** Wrapper element — 'div' by default, 'section' when semantically appropriate. */
  as?: 'div' | 'section'
  /** Extra classes for the header icon (e.g. colour). */
  iconClassName?: string
}

/**
 * Shared frame for profile settings cards (PhoneNumberCard, TaxInfoFormCard):
 * bordered card + header with an icon, uppercase title, and an optional
 * right-aligned action/badge. Consumers supply only the header content and
 * the body.
 */
export function ProfileCardShell({
  icon: Icon,
  title,
  right,
  children,
  as = 'div',
  iconClassName = 'text-primary',
}: ProfileCardShellProps) {
  const Wrapper = as
  return (
    <Wrapper className="rounded-xl border border-border bg-card p-6">
      <div className="mb-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Icon className={`size-4 shrink-0 ${iconClassName}`} />
          <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
            {title}
          </h3>
        </div>
        {right}
      </div>
      {children}
    </Wrapper>
  )
}
